import Entity from './entity'

export default class Address extends Entity<number>{
    countryCode:string;
    provinceCode:string;
    districtCode:string;
    wardCode:string;
    fullAddress :string;
    addressNo: string;
    provinceId:number;
    districtId:number;
    wardId:number;
}